<template>
  <div class="panel matriz-panel">
    <h3>Matriz de Posicionamiento por Categoría</h3>
    <p class="description">¿Quién es el competidor más barato con mayor frecuencia en cada categoría?</p>

    <div class="table-container">
      <table class="matriz-table">
        <thead>
          <tr>
            <th>Categoría</th>
            <th>Productos</th>
            <th>Líder</th>
            <th v-for="header in competitorHeaders" :key="header.key">
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="fila in matriz" :key="fila.categoria">
            <td class="category-name">{{ formatCategoryName(fila.categoria) }}</td>
            <td class="numeric">{{ fila.productos_competitivos }}</td>
            
            <td :class="{ 'es-ganador': esTokuGanador(fila.lider) }">
              {{ formatStoreName(fila.lider) }}
            </td>

            <td v-for="header in competitorHeaders" :key="header.key" class="numeric percentage">
              {{ fila.dominancia[header.key] }}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  matriz: {
    type: Array,
    default: () => []
  }
});

// CORREGIDO: Ahora lee las keys desde el primer objeto 'dominancia' que encuentra.
const competitorHeaders = computed(() => {
  if (!props.matriz || props.matriz.length === 0 || !props.matriz[0].dominancia) {
    return [];
  }
  const firstItemDominancia = props.matriz[0].dominancia;
  return Object.keys(firstItemDominancia)
    .map(key => ({
      key: key,
      text: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    }));
});

const formatCategoryName = (name) => {
  if (!name) return '';
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

// Nueva función para formatear el nombre del líder (ej: 'toku_importados' -> 'Toku Importados')
const formatStoreName = (name) => {
    if (!name) return '';
    return name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};

const esTokuGanador = (lider) => {
  return lider && lider.toLowerCase().includes('toku');
};
</script>

<style scoped>
.matriz-panel { 
  /* hereda .panel de main.css */
}
.description {
  font-size: 11.5px;
  color: var(--color-text-muted);
  margin: -4px 0 14px;
  font-family: 'Inter', sans-serif;
}
.table-container {
  overflow-x: auto;
  border: 1px solid var(--color-border);
  border-radius: 2px;
  background: var(--color-surface);
}
.matriz-table {
  width: 100%;
  border-collapse: collapse;
  font-family: var(--font-mono);
}
.matriz-table thead {
  background: var(--color-surface-3);
  border-bottom: 1px solid var(--color-accent-border);
}
.matriz-table th {
  text-align: left;
  padding: 8px 10px;
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-text-faint);
  border-bottom: 1px solid var(--color-border-strong);
  white-space: nowrap;
}
.matriz-table td {
  padding: 7px 10px;
  font-size: 11.5px;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text);
  font-variant-numeric: tabular-nums;
}
.matriz-table tbody tr:hover {
  background: var(--color-hover-row);
}
.matriz-table tbody tr:last-child td {
  border-bottom: none;
}
.category-name {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  color: var(--color-text);
}
.numeric {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.percentage {
  color: var(--color-text-muted);
}
.es-ganador {
  color: var(--color-success-text);
  font-weight: 700;
  background: var(--color-success-bg);
}
</style>
